import { render, staticRenderFns } from "./sys-user.vue?vue&type=template&id=4dd2651d&scoped=true&"
import script from "./sys-user.vue?vue&type=script&lang=js&"
export * from "./sys-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2651d",
  null
  
)

export default component.exports